"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingLabelInput = void 0;
var React = require("react");
var react_1 = require("react");
var FloatingLabelInputStyle_1 = require("./FloatingLabelInputStyle");
var InlineMessageComponent_1 = require("./InlineMessageComponent");
exports.FloatingLabelInput = function (props) {
    var _a = react_1.useState(false), fieldActivated = _a[0], setFieldActivated = _a[1];
    var callingOnChange = function (event, props) {
        props.onChange(event.target.value);
        if (props.inlineError) {
            props.setInLineError(false);
        }
        if (props.handleChange) {
            props.handleChange(event.target.value);
        }
    };
    var activateField = function () {
        console.log('');
        setFieldActivated(true);
    };
    var disableFocus = function (props) {
        if (props.value === '') {
            setFieldActivated(false);
        }
    };
    return (React.createElement(FloatingLabelInputStyle_1.BuilderContainer, null,
        React.createElement(FloatingLabelInputStyle_1.LabelContainer, { fieldActivated: true, inlineError: props.inlineError }, props.dispalyLabel),
        React.createElement(FloatingLabelInputStyle_1.FloatingLabelInputWrapper, { id: props.id, type: props.type, onChange: function (e) { return callingOnChange(e, props); }, onFocus: activateField, onBlur: function (e) { return disableFocus(props); }, fieldActivated: true, inlineError: props.inlineError, autoComplete: "new-password" }),
        props.inlineError ? (React.createElement(InlineMessageComponent_1.default, { inlineMsg: props.inlineMsg })) : ('')));
};
//# sourceMappingURL=FloatingLabelInput.js.map